import Vue from 'vue'
import {
  Container,
  Main,
  Header,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Aside,
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Col,
  Row,
  Radio,
  RadioGroup,
  Input,
  InputNumber,
  DatePicker,
  TabPane,
  Tabs,
  Select,
  Option,
  Table,
  TableColumn,
  Pagination,
  Loading,
  FormItem,
  Form,
  Tooltip,
  MessageBox,
  Message,
  Switch,
  Scrollbar,
  Tree,
  Dialog,
  Transfer,
  TimePicker,
  CheckboxGroup,
  Checkbox,
  Upload,
  Badge,
  Notification,
  Card,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
  Autocomplete,
  Progress,
  Popover,
  RadioButton,
  Carousel,
  CarouselItem,
  Divider,
  Avatar,
  Tag,
  Popconfirm,
  Alert
} from 'element-ui'
Vue.use(Container)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Avatar)
Vue.use(Main)
Vue.use(Header)
Vue.use(Button)
Vue.use(RadioButton)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Col)
Vue.use(Row)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Loading)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tooltip)
Vue.use(Switch)
Vue.use(Scrollbar)
Vue.use(Tree)
Vue.use(Dialog)
Vue.use(Transfer)
Vue.use(TimePicker)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Badge)
Vue.use(Card)
Vue.use(ButtonGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Autocomplete)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Divider)
Vue.use(Popconfirm)
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$alert = MessageBox.alert
